<template>
    <div>
        <card-header title="Contact Search" icon="fa-search"/>

        <card-body>
            <card-list>
                <search-list-item @action="runSearch"/>
                <subheader-list-item :title="title" icon="fa-address-book" :badge="contacts.length"/>
                <contact-list-item
                    :card="card"
                    :contact="c"
                    v-for="c in contacts"
                    :key="c.id"
                    :active="child && child.definition.component === 'contact' && String(child.props.contactId) === String(c.id)"
                    @click="$openCard('contact', {contactId: c.id}, card)"
                />
                <container-list-item padded v-if="!contacts.length">
                    <p class="has-text-grey is-size-7 my-2">No contacts match.</p>
                </container-list-item>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../TIER/components/CardHeader";
    import CardList from "../../TIER/components/CardList";
    import CardBody from "@/TIER/components/CardBody";
    import SearchListItem from "../../TIER/components/SearchListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import ContactListItem from "@/components/ContactListItem";
    import {client as http} from "@/http_client";

    export default {
        name: "SearchContacts",
        props: ['card', 'child', 'props'],
        components: {
            ContactListItem, ContainerListItem, SubheaderListItem,
            CardBody, SearchListItem, CardList, CardHeader
        },
        data: function () {
            return {
                contacts: [],
                query: ''
            };
        },
        computed: {
            title: function () {
                return this.query ? `Results for "${this.query}"` : 'All Contacts';
            }
        },
        methods: {
            runSearch(q) {
                this.query = typeof q === 'string' ? q : this.query;
                this.$emit('loading', true);
                const query = this.query ? '?q=' + encodeURIComponent(this.query) : '';
                http.get('/api/contacts' + query, {force: true}).then(response => {
                    this.contacts = response.data;
                    this.$emit('loading', false);
                });
            },
            reload: function () {
                this.runSearch(this.query);
            }
        },
        watch: {
            'props.query': function () {
                this.query = this.props.query || '';
                this.runSearch(this.query);
            }
        },
        mounted() {
            this.query = this.props.query || '';
            this.runSearch(this.query);
        }
    };
</script>
